export default __webpack_public_path__ + "static/media/protractor.6247e671.svg";